import { default as PropertyDetailPage } from './index';
import { getServerSideProps } from './index';

export { getServerSideProps };
export default PropertyDetailPage;
